import { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { api } from '../../lib/api';
import AraSec from '../../ui/AraSec';
import {
  Alan, Anahtar, DilAlan, DilAnahtari, GorselAlan, GorselListesi, Kart, KaydetCubugu, SayfaBaslik, SiteGorsel, Sonuc, YayinDugmesi, bosIkiDil,
  useCikisUyarisi, useSiteDurum, useTaslak, type Dil, type IkiDil,
} from './ortak';

type Proje = {
  id: string; slug: string; title: IkiDil; segment: string; city: string; year: number; years: number[];
  cover: string; gallery: string[]; products: string[]; body: IkiDil; featured: boolean; order: number;
};
type Form = Omit<Proje, 'id' | 'products' | 'years'> & { yillar: string };

const SEGMENT_AD: Record<string, string> = {
  otel: 'Otel', restoran: 'Restoran', kafe: 'Kafe', 'restoran-kafe': 'Restoran, kafe & mağaza', konut: 'Konut', magaza: 'Mağaza',
  ofis: 'Ofis', avm: 'AVM', saglik: 'Sağlık', kurumsal: 'Kurumsal', kamusal: 'Kamusal alan',
};
const bosForm = (sira: number): Form => ({
  slug: '', title: bosIkiDil(), segment: 'otel', city: 'İstanbul', year: new Date().getFullYear(), yillar: '',
  cover: '', gallery: [], body: bosIkiDil(), featured: false, order: sira,
});
const formaCevir = (p: Proje): Form => ({
  slug: p.slug, title: p.title, segment: p.segment, city: p.city, year: p.year, yillar: p.years.length === 1 && p.years[0] === p.year ? '' : p.years.join(', '),
  cover: p.cover, gallery: p.gallery.filter((g) => g !== p.cover), body: p.body, featured: p.featured, order: p.order,
});
const duz = (s: string) => s.toLocaleLowerCase('tr');

/** Site › Projeler — referans dizini. Kapak görseli olan proje sitede fotoğraflı kart ve detay sayfası olur. */
export function SiteProjeler() {
  const navigate = useNavigate();
  const { durum, yenile } = useSiteDurum();
  const [liste, setListe] = useState<Proje[] | null>(null);
  const [hata, setHata] = useState<string | null>(null);
  const [ara, setAra] = useState('');
  const [sekme, setSekme] = useState<'hepsi' | 'kapakli' | 'one'>('hepsi');

  useEffect(() => {
    api<{ projeler: Proje[] }>('/api/site/projeler').then((r) => setListe(r.projeler)).catch((e) => setHata((e as Error).message));
  }, []);

  const q = duz(ara.trim());
  const aranan = (liste ?? []).filter((p) => !q || duz(`${p.title.tr} ${p.title.en} ${p.city} ${SEGMENT_AD[p.segment] ?? p.segment} ${p.years.join(' ')}`).includes(q));
  const uyar = (p: Proje, s: typeof sekme) => s === 'hepsi' || (s === 'kapakli' ? Boolean(p.cover) : p.featured);
  const gorunen = aranan.filter((p) => uyar(p, sekme));

  return (
    <div className="ccd-stack">
      <SayfaBaslik baslik="Projeler" durum={durum}>
        <YayinDugmesi durum={durum} yenile={() => void yenile()} birincil={false} />
        <Link className="ccd-btn ccd-btn-primary" to="/site/projeler/yeni">Proje ekle</Link>
      </SayfaBaslik>
      <Sonuc bilgi={null} hata={hata} />

      <div className="ccd-card ccd-card-flush ccd-site-dizin-kart">
        <div className="ccd-site-arac">
          <div className="ccd-tabs" role="tablist">
            {([['hepsi', 'Tümü'], ['kapakli', 'Fotoğraflı'], ['one', 'Öne çıkan']] as const).map(([id, ad]) => (
              <button key={id} role="tab" aria-selected={sekme === id} className={`ccd-tab${sekme === id ? ' ccd-is-active' : ''}`} onClick={() => setSekme(id)}>
                {ad}{liste ? <span className="ccd-site-adet">{aranan.filter((p) => uyar(p, id)).length}</span> : null}
              </button>
            ))}
          </div>
          <div className="ccd-site-suz">
            <input className="ccd-input" type="search" placeholder="Proje, şehir, segment ya da yıl ara" aria-label="Projelerde ara" value={ara} onChange={(e) => setAra(e.target.value)} />
          </div>
        </div>
        {!liste ? (!hata && <div className="ccd-site-bosluk ccd-inline-note">Yükleniyor…</div>) : gorunen.length === 0 ? (
          <div className="ccd-site-bosluk">
            <div className="ccd-site-kart-baslik">{liste.length === 0 ? 'Henüz proje yok' : 'Bu süzgeçte proje yok'}</div>
            {liste.length === 0 && <div className="ccd-meta">Sitede bugünkü referans listesi kalır.</div>}
          </div>
        ) : (
          <div className="ccd-site-dizin-sar">
            <table className="ccd-table ccd-site-dizin">
              <thead>
                <tr><th className="ccd-th" aria-label="Kapak" /><th className="ccd-th">Proje</th><th className="ccd-th ccd-site-dar-gizle">Segment</th><th className="ccd-th ccd-site-dar-gizle">Şehir</th><th className="ccd-th">Yıl</th><th className="ccd-th ccd-td-num ccd-site-dar-gizle">Sıra</th></tr>
              </thead>
              <tbody>
                {gorunen.map((p) => (
                  <tr className="ccd-tr ccd-tr-clickable" key={p.id} onClick={() => navigate(`/site/projeler/${p.id}`)}>
                    <td className="ccd-td ccd-site-dizin-resim">{p.cover ? <SiteGorsel yol={p.cover} className="ccd-site-kucukresim" /> : <div className="ccd-site-kucukresim ccd-site-kucukresim-bos" />}</td>
                    <td className="ccd-td ccd-site-dizin-ad">
                      <Link className="ccd-site-dizin-bag" to={`/site/projeler/${p.id}`} onClick={(e) => e.stopPropagation()}>{p.title.tr}</Link>
                      {p.featured && <span className="ccd-badge" style={{ marginLeft: 8 }}>Öne çıkan</span>}
                    </td>
                    <td className="ccd-td ccd-site-dar-gizle">{SEGMENT_AD[p.segment] ?? p.segment}</td>
                    <td className="ccd-td ccd-site-dar-gizle">{p.city || <span className="ccd-muted">—</span>}</td>
                    <td className="ccd-td ccd-td-nowrap">{(p.years.length ? p.years : [p.year]).join(', ')}</td>
                    <td className="ccd-td ccd-td-num ccd-site-dar-gizle">{p.order}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

/** Site › Projeler › proje — solda ad, açıklama ve galeri; sağda durum, kapak ve ayrıntılar. */
export function SiteProje() {
  const { id } = useParams();
  const yeni = id === 'yeni';
  const navigate = useNavigate();
  const { durum, yenile } = useSiteDurum();
  const { f, setF, yukle, kirli, vazgec } = useTaslak<Form>();
  const [dil, setDil] = useState<Dil>('tr');
  const [bilgi, setBilgi] = useState<string | null>(null);
  const [hata, setHata] = useState<string | null>(null);
  const [mesgul, setMesgul] = useState(false);
  useCikisUyarisi(kirli);

  const getir = useCallback(async () => {
    const r = await api<{ projeler: Proje[] }>('/api/site/projeler');
    if (yeni) { yukle(bosForm(Math.max(0, ...r.projeler.map((p) => p.order)) + 1)); return; }
    const p = r.projeler.find((x) => x.id === id);
    if (!p) throw new Error('Proje bulunamadı');
    yukle(formaCevir(p));
  }, [id, yeni, yukle]);
  useEffect(() => { setBilgi(null); setHata(null); getir().catch((e) => setHata((e as Error).message)); }, [getir]);

  if (!f) return <div className="ccd-stack"><SayfaBaslik baslik="Proje" geri={{ to: '/site/projeler', ad: 'Projeler' }} /><Sonuc bilgi={null} hata={hata} />{!hata && <div className="ccd-inline-note">Yükleniyor…</div>}</div>;
  const al = <K extends keyof Form>(k: K, v: Form[K]) => { setBilgi(null); setF({ ...f, [k]: v }); };

  async function kaydet() {
    setBilgi(null); setHata(null); setMesgul(true);
    try {
      const { yillar, ...kalan } = f!;
      const years = yillar.split(/[\s,;]+/).filter(Boolean).map(Number);
      if (years.some((y) => !Number.isInteger(y))) throw new Error('Yıllar virgülle ayrılmış sayılar olmalı (örn. 2023, 2024)');
      const govde = JSON.stringify({ ...kalan, years });
      const r = yeni
        ? await api<{ proje: Proje }>('/api/site/projeler', { method: 'POST', body: govde })
        : await api<{ proje: Proje }>(`/api/site/projeler/${id}`, { method: 'PUT', body: govde });
      yukle(formaCevir(r.proje));
      setBilgi('Taslak kaydedildi. Sitede görünmesi için yayınlayın.');
      await yenile();
      if (yeni) navigate(`/site/projeler/${r.proje.id}`, { replace: true });
    } catch (err) { setHata(err instanceof Error ? err.message : 'Kaydedilemedi'); }
    finally { setMesgul(false); }
  }

  async function sil() {
    if (!window.confirm(`“${f!.title.tr}” referans listesinden silinsin mi? Bir sonraki yayında siteden de kalkar.`)) return;
    setHata(null);
    try { await api(`/api/site/projeler/${id}`, { method: 'DELETE' }); navigate('/site/projeler'); }
    catch (err) { setHata(err instanceof Error ? err.message : 'Silinemedi'); }
  }

  const segmentler = (durum?.secenekler.segmentler ?? Object.keys(SEGMENT_AD)).map((s) => ({ id: s, ad: SEGMENT_AD[s] ?? s }));
  return (
    <div className="ccd-stack">
      <KaydetCubugu acik={kirli} mesgul={mesgul} kaydet={() => void kaydet()} vazgec={() => { setHata(null); vazgec(); }} />
      <SayfaBaslik baslik={yeni ? 'Proje ekle' : f.title.tr || 'Proje'} geri={{ to: '/site/projeler', ad: 'Projeler' }} alt={yeni ? undefined : id}>
        <DilAnahtari dil={dil} degis={setDil} />
        {!yeni && <button type="button" className="ccd-btn ccd-btn-ghost" onClick={() => void sil()}>Sil</button>}
        <button type="button" className="ccd-btn ccd-btn-primary" disabled={mesgul || !kirli} onClick={() => void kaydet()}>{mesgul ? 'Kaydediliyor…' : 'Kaydet'}</button>
      </SayfaBaslik>
      <Sonuc bilgi={bilgi} hata={hata} />

      <div className="ccd-site-iki">
        <div className="ccd-stack ccd-site-iki-ana">
          <Kart>
            <DilAlan id="sp-ad" etiket="Proje adı" dil={dil} deger={f.title} degis={(v) => al('title', v)} azami={120} />
            <DilAlan id="sp-metin" etiket="Açıklama" dil={dil} deger={f.body} degis={(v) => al('body', v)} azami={2000} cokSatir satir={8} sayac
                     ipucu="Detay sayfasındaki paragraf; yalnız kapak görseli olan projede görünür." />
          </Kart>
          <Kart baslik="Galeri">
            <GorselListesi etiket="Ek fotoğraflar" deger={f.gallery} degis={(v) => al('gallery', v)} azami={19} bos="Detay sayfasında kapağın altında gösterilir." />
          </Kart>
        </div>

        <div className="ccd-stack ccd-site-iki-yan">
          <Kart baslik="Durum">
            <Anahtar acik={f.featured} degis={(v) => al('featured', v)} etiket="Öne çıkan proje" />
            <Alan id="sp-sira" etiket="Sıra" ipucu="Küçük sayı önce gelir; ana sayfada ilk 15 proje görünür.">
              <input id="sp-sira" className="ccd-input" inputMode="numeric" value={f.order} onChange={(e) => al('order', Number(e.target.value.replace(/\D/g, '').slice(0, 4)))} />
            </Alan>
          </Kart>

          <Kart baslik="Kapak görseli">
            <GorselAlan etiket="" genis deger={f.cover} degis={(v) => al('cover', v)} ipucu="Kapak eklenince proje fotoğraflı karta dönüşür ve detay sayfası açılır." />
          </Kart>

          <Kart baslik="Ayrıntılar">
            <Alan id="sp-seg" etiket="Segment">
              <AraSec id="sp-seg" secenekler={segmentler} deger={f.segment} degis={(v) => { if (v) al('segment', v); }} yerTutucu="Segment ara" />
            </Alan>
            <Alan id="sp-sehir" etiket="Şehir">
              <input id="sp-sehir" className="ccd-input" maxLength={60} value={f.city} onChange={(e) => al('city', e.target.value)} />
            </Alan>
            <Alan id="sp-yil" etiket="Yıl">
              <input id="sp-yil" className="ccd-input" inputMode="numeric" value={f.year || ''} onChange={(e) => al('year', Number(e.target.value.replace(/\D/g, '').slice(0, 4)))} />
            </Alan>
            <details className="ccd-tema-ileri">
              <summary>Birden çok yıla yayılan iş</summary>
              <Alan id="sp-yillar" etiket="İşin sürdüğü yıllar" ipucu="Virgülle ayırın. Boşsa yalnız yıl kullanılır.">
                <input id="sp-yillar" className="ccd-input" placeholder="2023, 2024" value={f.yillar} onChange={(e) => al('yillar', e.target.value)} />
              </Alan>
            </details>
          </Kart>

          <Kart baslik="Adres">
            <Alan id="sp-slug" etiket="Adres (slug)" ipucu="Boşsa proje adından üretilir.">
              <input id="sp-slug" className="ccd-input ccd-mono" maxLength={80} value={f.slug}
                     onChange={(e) => al('slug', e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '-').replace(/-{2,}/g, '-'))} />
            </Alan>
          </Kart>
        </div>
      </div>
    </div>
  );
}
